__turbopack_context__.v({
  "body": "styles-module-scss-module__br5OYW__body",
  "container": "styles-module-scss-module__br5OYW__container",
  "header": "styles-module-scss-module__br5OYW__header",
  "reloadButton": "styles-module-scss-module__br5OYW__reloadButton",
  "spotlight": "styles-module-scss-module__br5OYW__spotlight",
});
